import { createContext, useContext } from 'react'

export interface User {
  id: number
  username: string
  role: string
  must_change_password: boolean
}

export interface AuthContextType {
  user: User | null
  isAdmin: boolean
  setUser: (user: User | null) => void
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  isAdmin: false,
  setUser: () => {}
})

export function useAuth() {
  return useContext(AuthContext)
}
